import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const SaveIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const { sx, ...buttonProps } = props;
    const tooltipTitle = t('common.save', 'Save');

    return (
      <IconButton
        ref={ref}
        {...buttonProps}
        sx={{
          ...(props.color === 'secondary'
            ? {
                '&& .MuiSvgIcon-root': {
                  color: 'primary.main',
                },
                '&&:hover .MuiSvgIcon-root, &&:active .MuiSvgIcon-root, &&:focus-visible .MuiSvgIcon-root': {
                  color: 'common.white',
                },
              }
            : {}),
          ...sx,
        }}
        tooltipTitle={tooltipTitle}
      >
        <CheckIcon color='inherit' />
      </IconButton>
    );
  },
);

SaveIconButton.displayName = 'SaveIconButton';
export default SaveIconButton;
